<template>
  <div class="default-layout">
    <cookie-notification />
    <overlay v-if="overlayActive" />

    <div id="viewport" class="w-100 relative">
      <main-header />
      
      <div v-if="currentCatalog === config.rootcategories.biuro">
        <img
          src="/assets/Line_1.svg"
          alt="line"
          class="line-office top-line"
        />

        <img
          src="/assets/Line_2.svg"
          alt="line"
          class="line-office bottom-line"
        />
      </div>
      <div v-if="currentCatalog === config.rootcategories.drukowanie">
        <img
          src="/assets/ellipse-blue-big.svg"
          alt="blue"
          class="ellipse ellipse--blue"
        />

        <img
          src="/assets/ellipse-pink-big.svg"
          alt="blue"
          class="ellipse ellipse--pink"
        />

        <img
          src="/assets/ellipse-yellow-small.svg"
          alt="blue"
          class="ellipse ellipse--yellow"
        />
      </div>
      <async-sidebar
        :categoryProps="currentCatalog"
        :async-component="SearchPanel"
        :is-open="isSearchPanelOpen"
        @close="$store.commit('ui/setSearchpanel')"
      />
      <async-sidebar
        :categoryProps="currentCatalog"
        :async-component="Microcart"
        :is-open="isMicrocartOpen"
        @close="$store.commit('ui/setMicrocart')"
      />
      <async-sidebar
        :categoryProps="currentCatalog"
        :async-component="SidebarMenu"
        :is-open="isSidebarOpen"
        @close="$store.commit('ui/setSidebar')"
        direction="left"
      />
      <async-sidebar
        :categoryProps="currentCatalog"
        :async-component="Wishlist"
        :is-open="isWishlistOpen"
        @close="$store.commit('ui/setWishlist')"
      />
      <slot />
      <!-- <shop-info /> -->
      <div :class="officeInfo">
        <cms-block-chunk v-if="currentCatalog === config.rootcategories.biuro"  class="contact_phone" :identifier="`c_CONTACT_PHONE`" />
        <cms-block-chunk v-if="currentCatalog === config.rootcategories.drukowanie" class="contact_phone" :identifier="`c_CONTACT_PHONE_2`" />
      </div>
      <main-footer />
      <notification />
      <sign-up :categoryProps="currentCatalog" />
      <offline-badge />
      <order-confirmation :orders-data="ordersData" v-if="loadOrderConfirmation" />
    </div>
    <vue-progress-bar />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AsyncSidebar from 'theme/components/theme/blocks/AsyncSidebar/AsyncSidebar.vue'
import MainHeader from 'theme/components/core/blocks/Header/Header.vue'
import CookieNotification from 'theme/components/core/CookieNotification.vue'
import ShopInfo from "theme/components/theme/blocks/Static/ShopInfo"
import CmsBlockChunk from 'theme/components/core/blocks/Cms/BlockChunk'
import MainFooter from 'theme/components/core/blocks/Footer/Footer.vue'
import Overlay from 'theme/components/core/Overlay.vue'
import Notification from 'theme/components/core/Notification.vue'
import SignUp from 'theme/components/core/blocks/Auth/SignUp.vue'
import OfflineBadge from 'theme/components/core/OfflineBadge.vue'
import { isServer } from '@vue-storefront/core/helpers'
import Head from 'theme/head'
import RootCateogry from 'theme/mixins/rootCategory'
import config from 'config'

const SidebarMenu = () => import(/* webpackPreload: true */ /* webpackChunkName: "vsf-sidebar-menu" */ 'theme/components/core/blocks/SidebarMenu/SidebarMenu.vue')
const Microcart = () => import(/* webpackPreload: true */ /* webpackChunkName: "vsf-microcart" */ 'theme/components/core/blocks/Microcart/Microcart.vue')
const Wishlist = () => import(/* webpackPreload: true */ /* webpackChunkName: "vsf-wishlist" */ 'theme/components/core/blocks/Wishlist/Wishlist.vue')
const SearchPanel = () => import(/* webpackChunkName: "vsf-search-panel" */ 'theme/components/core/blocks/SearchPanel/SearchPanel.vue')
const OrderConfirmation = () => import(/* webpackChunkName: "vsf-order-confirmation" */ 'theme/components/core/blocks/Checkout/OrderConfirmation.vue')

export default {
  data () {
    return {
      officeDesign: '',
      officeInfo: '',
      loadOrderConfirmation: false,
      ordersData: [],
      Microcart,
      Wishlist,
      SearchPanel,
      SidebarMenu,
      config,
      cmsBlockIdentifier: 'm_TOP_MENU',
    }
  },
  mixins: [RootCateogry],
  computed: {
    ...mapState({
      overlayActive: state => state.ui.overlay,
      isSearchPanelOpen: state => state.ui.searchpanel,
      isSidebarOpen: state => state.ui.sidebar,
      isMicrocartOpen: state => state.ui.microcart,
      isWishlistOpen: state => state.ui.wishlist
    }),
  ...mapGetters({
      getCurrentCategory: 'category-next/getCurrentCategory',
      getCurrentProduct: 'product/getCurrentProduct',  
      getCMSBlocks: 'cmsBlock/cmsBlockIdentifier',    
    }),
    
    /**
     * Work on browser and SSR side and based only on data available on both sides
     */
    currentCatalog () {
      let catalog = this.getCurrentCategory ? this.getCurrentCategory.catalog : ''
      if (!catalog) { 
        catalog = this.getCurrentProduct ? this.getCurrentProduct.catalog : ''
      }    
      if (!catalog) { 
        const cmsData = this.getCMSBlocks(this.cmsBlockIdentifier);      
        if (cmsData) {    
          const result = JSON.parse(cmsData.content).filter(e => {          
            return e.categorySlug === this.getRootCategorySlug;
          });                
          if (result && result.length > 0 ) {
            catalog = result[0].categorySlug
          }      
        }      
      }
      return catalog;  
    }
  },
  methods: {
    // doesn't work on ssr
    isOffice () {      
      const baseUrl = this.$router.options.base            
      return baseUrl.startsWith(config.site.office_path)
    },
    // doesn't work on ssr
    isPrinting () {      
      const baseUrl = this.$router.options.base            
      return baseUrl.startsWith('/sklep')
    },
    onOrderConfirmation (payload) {
      this.loadOrderConfirmation = true
      this.ordersData = payload
      this.$bus.$emit('modal-show', 'modal-order-confirmation')
    },
    fetchMenuData () {
      return this.$store.dispatch('category-next/fetchMenuCategories', {
        level: config.entities.category.categoriesDynamicPrefetch && config.entities.category.categoriesDynamicPrefetchLevel >= 0
          ? config.entities.category.categoriesDynamicPrefetchLevel
          : null,
        skipCache: isServer
      })
    }
  },
  serverPrefetch () {
    return this.fetchMenuData()
  },
  beforeMount () {
    // Progress bar on top of the page
    this.$router.beforeEach((to, from, next) => {
      this.$Progress.start()
      this.$Progress.increase(40)
      next()
    })
    this.$router.afterEach((to, from) => {
      this.$Progress.finish()
    })
    this.$bus.$on('offline-order-confirmation', this.onOrderConfirmation)
  },
  beforeDestroy () {
    this.$bus.$off('offline-order-confirmation', this.onOrderConfirmation)
  },
  mounted () {
    if (this.isPrinting()) {
      this.officeInfo = 'bottom-info' 
    } else if (this.isOffice()) {
      this.officeInfo = 'bottom-info_office'
    }
  },
  metaInfo: Head,
  components: {
    MainHeader,
    CmsBlockChunk,
    CookieNotification,
    MainFooter,
    SidebarMenu, // eslint-disable-line vue/no-unused-components
    Overlay,
    Notification,
    SignUp,
    OfflineBadge,
    OrderConfirmation,
    AsyncSidebar,
    ShopInfo
  }
}
</script>

<style lang="scss" src="theme/css/main.scss"></style>
<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  .bottom-info_office {
    height: 40px;
    background: $office-primary;
    color: $white;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;

    p {
      margin: 0;
    }
  }
  .bottom-info {
    background: $indigo;
    color: $white;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;

    p {
      margin: 0;
    }
  }
</style>
